var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefferal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.72131C8.603 2.72131 9.5 3.67508 9.5 4.84789C9.5 6.0207 8.603 6.97447 7.5 6.97447C6.397 6.97447 5.5 6.0207 5.5 4.84789C5.5 3.67508 6.397 2.72131 7.5 2.72131ZM7.5 9.10106C9.706 9.10106 11.5 7.19351 11.5 4.84789C11.5 2.50227 9.706 0.594727 7.5 0.594727C5.294 0.594727 3.5 2.50227 3.5 4.84789C3.5 7.19351 5.294 9.10106 7.5 9.10106ZM7.5 11.2276C3.641 11.2276 0.5 14.5664 0.5 18.6707C0.5 19.2576 0.947 19.734 1.5 19.734C2.053 19.734 2.5 19.2576 2.5 18.6707C2.5 15.7392 4.743 13.3542 7.5 13.3542C10.257 13.3542 12.5 15.7392 12.5 18.6707C12.5 19.2576 12.947 19.734 13.5 19.734C14.053 19.734 14.5 19.2576 14.5 18.6707C14.5 14.5664 11.359 11.2276 7.5 11.2276ZM17.5 3.7846H18.5C19.05 3.7846 19.5 4.26308 19.5 4.84789C19.5 5.4327 19.05 5.91118 18.5 5.91118H17.5V6.97447C17.5 7.55928 17.05 8.03776 16.5 8.03776C15.95 8.03776 15.5 7.55928 15.5 6.97447V5.91118H14.5C13.95 5.91118 13.5 5.4327 13.5 4.84789C13.5 4.26308 13.95 3.7846 14.5 3.7846H15.5V2.72131C15.5 2.1365 15.95 1.65802 16.5 1.65802C17.05 1.65802 17.5 2.1365 17.5 2.72131V3.7846Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferal);
export default __webpack_public_path__ + "static/media/refferal.c632c8ce6a06bd17b3ebefe7cdb2c6f1.svg";
export { ForwardRef as ReactComponent };